import { SingleOperation } from "./Operation";
import { Verb } from "../types/Verb";
import { makeAttributeList } from "../ShapeStore";
import { NodeShape } from "../standardShapes/NodeShape";

export default class AddImagesOperation extends SingleOperation {
  shapePrototypes: NodeShape[];

  constructor(newShapeIDs: string[], shapePrototypes: NodeShape[]) {
    super(
      shapePrototypes.map((s, i) => ({
        verb: Verb.UpsertSubjectAttributeMany,
        subjectID: newShapeIDs[i],
        version: -1,
        attributes: makeAttributeList({ ...s }),
      })),
      newShapeIDs.map((id) => ({
        verb: Verb.DeleteShape,
        subjectID: id,
      }))
    );
    this.shapePrototypes = shapePrototypes;
  }

  get label(): string {
    return `Add ${this.shapePrototypes.length} images`;
  }
}
